<template>
  <v-card elevation="8" class="graph__card ma-5 mt-10">
    <v-container fluid>
      <v-row justify="center" class="ma-0">
        <h2 class="font-weight-bold">Análise de consumo de ração</h2>
      </v-row>
      <v-form v-model="isValid" ref="form">
        <v-row class="ma-0">
          <!--    Exploration Unit    -->
          <v-col cols="12" sm="6" md="3" lg="3" xl="3">
            <v-autocomplete
              :rules="[campoSelectObrigatorio]"
              v-model="queryParams.csTipoUep"
              :items="explorationUnitTypes"
              color="primary"
              item-text="dsTipoUnidadeExploracao"
              item-value="csTipoUnidadeExploracao"
              label="Tipo de Unidade Exploração"
              no-data-text="Nenhum registro"
              outlined
              clearable
            />
          </v-col>
          <!--    Gender    -->
          <v-col cols="12" sm="6" md="3" lg="3" xl="3">
            <v-autocomplete
              v-model="queryParams.sgSexo"
              :items="genderTypes"
              clearable
              color="primary"
              item-text="dsSexo"
              item-value="sgSexo"
              label="Gênero dos animais"
              outlined
            />
          </v-col>
          <!--    Status    -->
          <v-col cols="12" sm="6" md="3" lg="3" xl="3">
            <v-autocomplete
              v-model="queryParams.flAberto"
              :items="statusList"
              color="primary"
              label="Status do Lote"
              no-data-text="Nenhum registro"
              outlined
              clearable
            />
          </v-col>
          <!--    Extensionist    -->
          <v-col cols="12" sm="6" md="3" lg="3" xl="3">
            <v-autocomplete
              v-model="queryParams.cdResponsavelTecnico"
              :items="extensionists"
              clearable
              color="primary"
              item-text="displayName"
              item-value="idResponsavelTecnico"
              label="Extensionista"
              outlined
            />
          </v-col>
          <!--    Feed Consumption Table    -->
          <v-col cols="12" sm="6" md="3" lg="3" xl="3">
            <v-autocomplete
              v-model="cdTabelaConsumoRacao"
              :items="feedConsumptionTables"
              clearable
              color="primary"
              item-text="nmTabela"
              item-value="idTabelaConsumoRacao"
              label="Tabela de Consumo"
              outlined
            />
          </v-col>
          <!--    Graph show type    -->
          <v-col cols="12" sm="6" md="3" lg="3" xl="3">
            <v-autocomplete
              :rules="[campoObrigatorio]"
              v-model="graphShowType"
              :items="graphShowTypeList"
              clearable
              color="primary"
              label="Tipo de Exibição"
              outlined
            />
          </v-col>
          <!--    Date filter type    -->
          <v-col cols="12" sm="6" md="3" lg="3" xl="3">
            <v-select
              outlined
              label="Tipo de filtro de data"
              v-model="byMonthType"
              :items="monthTypesItems"
            />
          </v-col>
          <!--    Date filter    -->
          <v-col cols="12" sm="6" md="3" lg="3" xl="3">
            <SelectMonth
              :rules="[campoObrigatorio]"
              :label="monthDateLabel"
              :readonly="true"
              v-model="dtByMonth"
              clearable
            ></SelectMonth>
          </v-col>
          <!--    Feed Consumption Table    -->
          <v-col cols="12" sm="6" md="3" lg="3" xl="3">
            <v-btn id="search" dark rounded color="primary" @click="loadConsumptionData" >
              <span class="marginSpan"> Atualizar </span>
              <v-icon small style="margin-left: 4px; margin-bottom: 2px">fa-sync-alt</v-icon>
            </v-btn>
            <v-btn id="clear" rounded color="#e8e8e8" @click="clearData" style="margin-left: 5px;">
              <span class="marginSpan"> Limpar Busca </span>
              <v-icon small style="margin-left: 4px; margin-bottom: 2px">fas fa-eraser</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
      <v-row
        class="ma-0"
      >
        <v-chip
          v-for="item in selectedIndexes"
          :key="item"
          close
          small
          @click:close="() => onChipCloseClick(item)"
          class="ma-1"
        >
          {{ item | indexDisplay }}
        </v-chip>
      </v-row>
      <v-row class="ma-0">
        <!-- Graph -->
        <v-col cols="12">
          <FeedConsumptionGraph
            :graph-data="graphData"
            :cd-consumption-table="cdTabelaConsumoRacao"
            :graph-show-type="graphShowType"
          />
        </v-col>
        <!-- Table -->
        <v-col cols="12">
          <v-data-table
            :headers="tableHeaders"
            :items="tableData"
            :sort-by="['semana_do_lote']"
            @click:row="goToLote"
          />
        </v-col>
      </v-row>
    </v-container>
    <AppLoaderBlockCard :overlay="isLoading" />
  </v-card>
</template>

<script>
import Vue from "vue"
import SelectMonth from "@/components/general/SelectMonth"
import {campoObrigatorio, campoSelectObrigatorio,} from "@/filters/rules"
import * as moment from "moment"
import axios from "axios"
import AppLoaderBlockCard from "@/components/layout/AppLoaderBlockCard"
import FeedConsumptionGraph from "@/pages/Analise/FeedConsumption/FeedConsumptionGraph"

const MONTH_TYPES = {
  BY_CLOSING_DATE: "BY_CLOSING_DATE",
  BY_ACCOMMODATION_DATE: "BY_ACCOMODATION_DATE",
}
const MONTH_TYPES_TO_ITEMS = [
  {
    text: "Data de fechamento",
    value: MONTH_TYPES.BY_CLOSING_DATE,
  },
  {
    text: "Data de alojamento",
    value: MONTH_TYPES.BY_ACCOMMODATION_DATE,
  },
]

const toDetailsView = entry => {
  entry.consumo = entry.consumo.toFixed(3)
  entry.consumo_esperado = entry.consumo_esperado ? entry.consumo_esperado.toFixed(3) : '---'
  return entry
}

const toResumeView = entry => {
  const tabela = 0
  return {...entry, tabela}
}

const defaultQueryParams = () => ({
  flAberto: false,
  csTipoUep: null,
  sgSexo: null,
  cdResponsavelTecnico: null,
  dtInicioAlojamento: null,
  dtFimAlojamento: null,
  dtInicioFechamento: null,
  dtFimFechamento: null,
})

export default {
  name: "FeedConsumption",
  components: {FeedConsumptionGraph, AppLoaderBlockCard, SelectMonth},
  data() {
    return {
      isValid: false,
      isLoading: false,
      
      graphShowType: null,
      byMonthType: MONTH_TYPES.BY_CLOSING_DATE,
      dtByMonth: null,
      cdTabelaConsumoRacao: null,
      queryParams: defaultQueryParams(),
      
      graphData: {},
      tableData: [],
      
      selectedIndexes: []
    }
  },
  filters: {
    indexDisplay(value) {
      return value.replace("CLOSING_", "Fechamento ").replace("ACCOMMODATION_", "Alojamento ")
    }
  },
  computed: {
    statusList() {
      return [
        {
          text: "Aberto",
          value: "AB",
        },
        {
          text: "Fechado",
          value: "FC",
        },
      ]
    },
    graphShowTypeList() {
      return [
        {
          text: "Acumulado",
          value: "AC",
        },
        {
          text: "Diário",
          value: "DI",
        },
      ]
    },
    tableHeaders() {
      return [
        {text: "Semana do Lote", value: "semana_do_lote"},
        {text: "Produtor", value: "lote_producao.jsonProdutor.nmProdutor"},
        {text: "Pavilhão", value: "lote_producao.nrPavilhao"},
        {text: "Lote Controle", value: "lote_producao.nrLoteControle"},
        {text: "Consumo (kg)", value: "consumo"},
        {text: "Consumo Esperado (kg)", value: "consumo_esperado"},
      ]
    },
    
    // Vuex Lists
    extensionists() {
      return this.$store.state.extensionistas
    },
    genderTypes() {
      return this.$store.state.tiposGenero
    },
    explorationUnitTypes() {
      return this.$store.state.tiposUnidadesExploracao
    },
    feedConsumptionTables() {
      return this.$store.state.tabelasConsumoRacao
    },
    monthTypesItems() {
      return MONTH_TYPES_TO_ITEMS
    },
    monthDateLabel() {
      if (this.byMonthType === MONTH_TYPES.BY_CLOSING_DATE)
        return "Mês de fechamento"
      return "Mês de alojamento"
    },
  },
  methods: {
    campoObrigatorio,
    campoSelectObrigatorio,
    goToLote(item) {
      this.$router.push({name: 'loteProducao', params: {id: item.lote_producao.idLoteProducao}})
    },
    clearData() {
      this.graphData = {}
      this.tableData = []
      this.selectedIndexes = []
      this.queryParams = {}
      this.graphShowType =  null
      this.byMonthType = MONTH_TYPES.BY_CLOSING_DATE
      this.dtByMonth = null
      this.cdTabelaConsumoRacao = null
    },
    onChipCloseClick(value) {
      const idx = this.selectedIndexes.findIndex(item => item === value)
      if (idx > -1) {
        this.selectedIndexes.splice(idx, 1)
      }
      delete this.graphData[value]
      this.graphData = Object.assign({}, this.graphData, this.graphData)
    },
    clearAll() {
      this.selectedIndexes = Object.assign([], [])
      this.graphData = Object.assign({}, {})
    },
    loadConsumptionData() {
      if (!this.$refs.form.validate()) return
      this.isLoading = true
      this.dadosConsumo = []
      
      let timeFilters = {}
      let graphDateIndex = "MEDIA"
      delete this.graphData["MEDIA"]
      this.graphData = Object.assign({}, this.graphData, this.graphData)
      if (this.byMonthType === MONTH_TYPES.BY_CLOSING_DATE) {
        const dtByMonth = moment(this.dtByMonth, "MM/Y")
        if (dtByMonth.isValid()) {
          const dtInicioFechamento = dtByMonth.startOf("month").toISOString()
          const dtFimFechamento = dtByMonth.endOf("month").toISOString()
          timeFilters["dtInicioFechamento"] = dtInicioFechamento
          timeFilters["dtFimFechamento"] = dtFimFechamento

          let genero = ''
          if (this.queryParams.sgSexo == 'MA') {
            genero = ' - Macho'
          }
          else if (this.queryParams.sgSexo == 'FE') {
            genero = ' - Fêmea'
          }
          else if (this.queryParams.sgSexo == 'MI') {
            genero = ' - Misto'
          }

          graphDateIndex = `CLOSING_${dtByMonth.format("MM/Y")}${genero}`
          const idx = this.selectedIndexes.findIndex(item => item === graphDateIndex)
          if (idx > -1) {
            this.selectedIndexes.splice(idx, 1, graphDateIndex)
          } else {
            this.selectedIndexes.push(graphDateIndex)
          }
        }
      } else if (this.byMonthType === MONTH_TYPES.BY_ACCOMMODATION_DATE) {
        const dtByMonth = moment(this.dtByMonth, "MM/Y")
        if (dtByMonth.isValid()) {
          const dtInicioAlojamento = dtByMonth.startOf("month").toISOString()
          const dtFimAlojamento = dtByMonth.endOf("month").toISOString()
          timeFilters["dtInicioAlojamento"] = dtInicioAlojamento
          timeFilters["dtFimAlojamento"] = dtFimAlojamento
          
          let genero = ''
          if (this.queryParams.sgSexo == 'MA') {
            genero = ' - Macho'
          }
          else if (this.queryParams.sgSexo == 'FE') {
            genero = ' - Fêmea'
          }
          else if (this.queryParams.sgSexo == 'MI') {
            genero = ' - Misto'
          }
          
          graphDateIndex = `ACCOMMODATION_${dtByMonth.format("MM/Y")}${genero}`
          const idx = this.selectedIndexes.findIndex(item => item === graphDateIndex)
          if (idx > -1) {
            this.selectedIndexes.splice(idx, 1, graphDateIndex)
          } else {
            this.selectedIndexes.push(graphDateIndex)
          }
        }
      }
      
      if (graphDateIndex === "MEDIA") this.clearAll()
      
      const filters = {
        flAberto: (
          (this.queryParams.flAberto === "AC")
            ? true : (this.queryParams.flAberto === "FC") ? false : null
        ),
        csTipoUep: this.queryParams.csTipoUep,
        sgSexo: this.queryParams.sgSexo,
        cdResponsavelTecnico: this.queryParams.cdResponsavelTecnico,
        ...timeFilters,
      }
      if (this.graphShowType === "AC") {
        axios.get("analises/consumo-acumulado/", {
            params: filters,
          })
          .then((response) => {
            let data = response.data
            this.parseResponseData(data, graphDateIndex)
          })
          .finally(() => {
            this.isLoading = false
          })
      } else {
        axios.get("analises/consumo-diario/", {
            params: filters,
          })
          .then((response) => {
            let data = response.data
            this.parseResponseData(data, graphDateIndex)
          })
          .finally(() => {
            this.isLoading = false
          })
      }
    },
    parseResponseData(data, graphDateIndex) {
      if (!data) return
      if (!data.resumo) return
      if (!data.resumo.length)  {
        const idx = this.selectedIndexes.findIndex(item => item === graphDateIndex)
        if (idx > -1) this.selectedIndexes.splice(idx, 1)
        this.$store.commit("setSnack", {
          type: "error",
          msg: "Não há dados de consumo com os filtros e o mês selecionado"
        })
        return
      }
      
      // Get Table Data
      if (data.detalhes) this.tableData = data.detalhes.map(toDetailsView)
      
      if (data.resumo) {
        delete this.graphData[graphDateIndex]
        Vue.set(this.graphData, graphDateIndex, data.resumo.map(toResumeView))
      }
    },
  },
  mounted() {
    this.$store.dispatch("actLoadExtensionistas")
    this.$store.dispatch("actLoadTabelasConsumoRacao")
  }
}
</script>

<style scoped lang="scss">
.graph__card {
  border-top: 3px solid #10303d;
}
</style>
